import { useState } from "react";
import { ChartBar, CaretDown } from "@phosphor-icons/react";

const BAND_TONE = { Low: "badge-success", Medium: "badge-warning", High: "badge-danger" };

/** Shows the borrower their risk-priced monthly rate and a plain-language reason for it. */
export default function RateExplanation({ ratePct, band, score, explanation, votes, testid = "rate-explanation" }) {
  const [open, setOpen] = useState(false);
  if (ratePct == null) return null;
  return (
    <div className="rounded-2xl border border-[#0A3622]/20 bg-[#E2F3EB]/30 p-5 mb-5" data-testid={testid}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="overline !text-[#2D7A5D]">Your interest rate</div>
          <div className="font-display text-3xl font-semibold text-[#0A3622] mt-1" data-testid={`${testid}-rate`}>{Number(ratePct).toFixed(2).replace(/\.?0+$/, "")}% <span className="text-base font-medium text-[#4F5D4F]">per month</span></div>
        </div>
        {band && <span className={`badge ${BAND_TONE[band] || "badge-neutral"}`} data-testid={`${testid}-band`}>{band} risk{score != null ? ` · ${score}/1000` : ""}</span>}
      </div>
      {explanation?.length > 0 && (
        <div className="mt-3 text-sm text-[#132A13] space-y-1.5" data-testid={`${testid}-why`}>
          <p className="font-medium">{explanation[0]}</p>
          <ul className="list-disc pl-5 text-[#4F5D4F] space-y-1">{explanation.slice(1).map((l) => <li key={l}>{l}</li>)}</ul>
        </div>
      )}
      <p className="text-xs text-[#4F5D4F] mt-3">Rates run from 3% (lowest risk) to 8% a month, set by seven independent credit models voting together.</p>
      {votes?.length > 0 && (
        <>
          <button type="button" onClick={() => setOpen(!open)} className="text-xs text-[#0A3622] underline mt-2 inline-flex items-center gap-1" data-testid={`${testid}-toggle-votes`}>
            <ChartBar size={12} /> How each model voted <CaretDown size={10} className={open ? "rotate-180" : ""} />
          </button>
          {open && (
            <div className="mt-2 grid sm:grid-cols-2 gap-1.5 text-xs" data-testid={`${testid}-votes`}>
              {votes.map((v) => (
                <div key={v.key} className="flex justify-between gap-2 bg-white rounded-lg px-3 py-1.5 border border-[#E5E3DB]">
                  <span>{v.model}</span><span className="font-mono">{v.band} · {(v.weight * 100).toFixed(0)}% weight</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
